<style lang="scss"></style>

<template>
  <div style="overflow: auto;height: 100%;position: relative;">
    <div class="titleBar" style="display: flex;align-items:center ;position: sticky;top: 0;background: #202027;padding: 20px;padding-bottom: 14px;">
      <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
      <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
        {{ $t('baojingxinxi') }}
      </p>
      <div style="flex: 1;display: flex;justify-content: flex-end;align-items: center;">
        <el-link @click="hideOrShowEnded()" style="color:#419FFF ;font-size: 12px;" icon="yicon yicon-eye_off_line">{{ isAlertShowEnded == 'true' ? $t('yincangyijieshu') : $t('xianshiyijieshu') }}</el-link>
      </div>
    </div>
    <div class="alerts" style="padding: 20px;">
      <div class="alert" style="margin-bottom: 26px;" v-for="alert in alerts" v-if="alert.flag == 1 || (alert.flag != 1 && isAlertShowEnded == 'true')">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <p style="font-size: 18px;color: #419FFF;">{{ alert.name }}</p>
          <p style="color: #F4F4F4;" :style="{ 'font-size': monitorSetting.MONITOR_WORKSHOP_ALERT_FONT + 'px' }">{{ $t(alert.i18n) }}</p>
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;margin-top: 8px;">
          <div :style="{ background: alert.flag == 1 ? '#C6164B' : '#292F3E' }" style="font-size:10px;color: #F4F4F4;border-radius:12px ;padding: 2px 8px;display: flex;justify-content: center;align-items: center;flex-shrink: 0;">
            {{ alert.flag == 1 ? $t('jinxingzhong') : $t('yijieshu') }}
          </div>
          <p style="color: #858A93;text-align: right;" :style="{ 'font-size': monitorSetting.MONITOR_WORKSHOP_ALERT_FONT + 'px' }">
            <span>{{ dayjs(alert.begin).format('MM-DD HH:mm') }}</span>
            <span v-if="alert.flag != 1">~{{ dayjs(alert.end).format('MM-DD HH:mm') }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="bottomBar" style="width: 100%;height: 20px;position: sticky;bottom: 0;background: #202027;"></div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_workshop_mes_alert',
  components: {},

  data() {
    return {
      isAlertShowEnded: localStorage.getItem('IS_WORKSHOP_ALERT_SHOW_ENDED'),
      timmer: null,
      alerts: [],
      monitorSetting: null
    };
  },
  created() {
    this.setCardSetting();
    this.timmer = setInterval(() => {
      this.listAlarm();
    }, 120000);
    this.listAlarm();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.utils.event_hub.$on('SetCard', () => {
      this.setCardSetting();
    });
    this.setCardSetting();
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listAlarm();
    }
  },
  destroyed() {
    this.utils.event_hub.$off('SetCard');
    clearInterval(this.timmer);
  },
  methods: {
    setCardSetting() {
      this.monitorSetting = JSON.parse(localStorage.getItem('MONITOR_SETTING'));
      if (this.monitorSetting == null) {
        this.monitorSetting = {};
      }
      if (this.monitorSetting.MONITOR_WORKSHOP_ALERT_FONT == null) {
        this.monitorSetting.MONITOR_WORKSHOP_ALERT_FONT = 14;
      }
    },
    hideOrShowEnded() {
      if (this.isAlertShowEnded == 'true') {
        this.isAlertShowEnded = 'false';
      } else {
        this.isAlertShowEnded = 'true';
      }
      localStorage.setItem('IS_WORKSHOP_ALERT_SHOW_ENDED', this.isAlertShowEnded);
    },
    async listAlarm() {
      let response = await this.http.get('/web/equipment/listAlarm', {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      this.alerts = response.data;
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {}, 800);
    }
  }
};
</script>
